<div>
    <h2 class="menu-title">Menú Principal</h2>
    <div class="launcher-container">
        <mat-form-field appearance="outline" class="search-bar">
            <mat-label>Buscar</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="text" placeholder="Buscar módulo..." [(ngModel)]="search" />
            @if (search) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="search = ''">
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>

        <div class="grid">
            @if (isLoading()) {
            <div class="loading-container">
                <mat-spinner diameter="50"></mat-spinner>
                <p>Cargando permisos...</p>
            </div>
            } @else {
            @for (app of filteredApps(); track app.label) {
            <div class="app-icon" (click)="navigateTo(app.route)" [class.disabled]="app.disabled">
                <div class="icon-circle">
                    <mat-icon>{{ app.icon }}</mat-icon>
                </div>
                <div class="icon-label">{{ app.label }}</div>
            </div>
            } @empty {
            <div class="no-apps-message">
                <mat-icon>lock</mat-icon>
                <p>No tienes permisos para ver ninguna aplicación.</p>
                <p class="sub-text">Contacta a tu administrador para solicitar acceso.</p>
            </div>
            }
            }
        </div>
    </div>
</div>